import React, { useEffect } from "react";
import { Container, Typography } from "@mui/material";
import DocumentGrid from "components/DocumentGrid/DocumentGrid";
import "./LibraryPage.scss";
import { useLibraryStore } from "store/LibraryStore";

const LibraryPage = () => {
  const { library, fetchLibrary } = useLibraryStore();

  useEffect(() => {fetchLibrary()}, [fetchLibrary]);

  return (
    <Container id="library-page">
      <Typography variant="h4">Moja Biblioteka</Typography>
      <DocumentGrid documents={library}/>
    </Container>
  );
};

export default LibraryPage;
